import React from "react"

const Facebook = () => {
	return (
		<svg width="11.004" height="17.976" viewBox="0 0 11.004 17.976">
			<path
				id="Forma_1_copy_4"
				data-name="Forma 1 copy 4"
				d="M10.589,0,7.951,0C4.985,0,3.068,1.736,3.068,4.424V6.463H.414A.392.392,0,0,0,0,6.831V9.785a.392.392,0,0,0,.414.367H3.068v7.457a.393.393,0,0,0,.416.367H6.946a.4.4,0,0,0,.416-.367V10.152h3.1a.393.393,0,0,0,.415-.367V6.831a.347.347,0,0,0-.122-.26.444.444,0,0,0-.293-.108h-3.1V4.734c0-.831.224-1.253,1.45-1.253h1.778A.393.393,0,0,0,11,3.114V.37A.393.393,0,0,0,10.589,0Z"
				fill="#88c8bc"
			/>
		</svg>
	)
}

export default Facebook
